import React, { useState } from 'react';
import style from './index.module.scss';
import Header from './Header';
import Compare from './Compare';
import Trend from './Trend';

const Page = (props) => {
    const [sysInfo, setSysInfo] = useState(null);

    return (
        <div className={style['wrapper']}>
            <Header sysInfo={sysInfo} setSysInfo={setSysInfo} />
            <div className="content_wrapper">
                <div className="left">
                    <Compare />
                </div>
                <div className="mid">
                    <Trend />
                </div>
            </div>
        </div>
    );
};

export default Page;
